import firebase from "firebase/app";
import "firebase/functions";

export const createUser = async (email, provider, name, surname) => {
  let callable = firebase.functions().httpsCallable("createUser");
  return callable({ email, provider, name, surname }).then(
    result => result.data
  );
};
export const updateUser = async data => {
  let callable = firebase.functions().httpsCallable("updateUser");
  return callable(data).then(result => result.data);
};
export const validateUser = async email => {
  let callable = firebase.functions().httpsCallable("validateUser");
  return callable({ email }).then(result => result.data);
};

export const resendInvitation = async uid => {
  let callable = firebase.functions().httpsCallable("resendInvitation");
  return callable({ uid }).then(result => result.data);
};
